import React from "react";
import { MDXProvider } from "@mdx-js/react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { Script } from "gatsby";
import classNames from "classnames";
import { CookieBanner } from "@app/components/common/cookie-banner/CookieBanner";
import { Modals } from "@app/components/common/modals/Modals";
import { Header, Footer } from "@app/components/common";
import { ChatbotLoader } from "@app/components/common/chatbot-loader/ChatbotLoader";
import { useViewVariant } from "@app/hooks/use-view-variant/useViewVariant";
import {
  CookieConsentProvider,
  DownloadAppTopbarProvider,
  ModalProvider,
  ViewVariantProvider,
} from "@app/context";
import { SEO } from "@app/components";

export const Layout = (props) => (
  <GoogleReCaptchaProvider reCaptchaKey={process.env.GATSBY_RECAPTCHA_V3_KEY}>
    <CookieConsentProvider>
      <DownloadAppTopbarProvider>
        <ModalProvider>
          <ViewVariantProvider>
            <InnerLayout {...props} />
          </ViewVariantProvider>
        </ModalProvider>
      </DownloadAppTopbarProvider>
    </CookieConsentProvider>
  </GoogleReCaptchaProvider>
);

const InnerLayout = ({ children, pageContext, location }) => {
  const { isContentOnly } = useViewVariant();
  const showFooter = !location.pathname.includes("/wealth-management-advice");

  return (
    <>
      {!isContentOnly && (
        <>
          <Script src="https://www.chatbase.co/embed.min.js" strategy="idle" />
          <Script
            id="sleeknoteScript"
            src="https://sleeknotecustomerscripts.sleeknote.com/171436.js"
            strategy="idle"
          />
        </>
      )}
      <SEO {...pageContext.seo} />
      <div className="flex min-h-screen flex-col justify-between">
        {!isContentOnly && <Header />}
        <MDXProvider components={{}}>
          <main className={classNames("duration-300")}>{children}</main>
        </MDXProvider>
        {!isContentOnly && <CookieBanner />}
        {!isContentOnly && showFooter && <Footer />}
        <Modals />
      </div>
      <ChatbotLoader />
    </>
  );
};

export default Layout;
